import mutations from "./mutations"
import actions from "./actions"
import getters from "./getters"
export default {
    namespaced:true ,
    state(){
        return{
            wholeSales : [],
            AllwholeSales : [],
            wholeSaleDetail : [],
            wholeSaleOrders : [],
           wholeSaleLoaded:false,
           postOrderWholesale:false,
           changingStatus:false,
           wholeSaleorderLoaded:false,
           postWholesale:false,
           deleteing:false,

        }
    },
    mutations,
    getters,
    actions,
}
